// extracted by mini-css-extract-plugin
module.exports = {"centeredColumn":"CenterLayout_centeredColumn__38ekk","noBorder":"CenterLayout_noBorder__1QJQj"};